




















import { computed, defineComponent, ref } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { AvailabilityIntervalType } from "@scrile/api-provider/dist/projects/scrileConnect/UserAvailabilityProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { Tab } from "@/types";
import AppointmentAvailabilitySettings from "@/components/AppointmentAvailabilitySettings";
import AppointmentTypesSettings from "@/components/AppointmentTypesSettings";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BasePage from "@/components/BasePage";
import BaseTabs from "@/components/BaseTabs";
import Divider from "@/components/Divider";
import ListItem from "@/components/ListItem";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PageAppointmentsEditSettings",
  components: {
    Divider,
    BaseTabs,
    ListItem,
    AppointmentTypesSettings,
    AppointmentAvailabilitySettings,
    PageTitle,
    BasePage,
    BaseIcon,
    BaseIconButton,
    BaseConfirm,
    BaseButton,
  },
  props: {
    type: { type: String as () => AvailabilityIntervalType },
  },
  setup() {
    const { authorities } = useAuthUser();
    const itemsTabs: (Tab & { component: any })[] = [
      ...(checkAuthorities(authorities.value, ["updateMyUserAvailability"])
        ? [
            {
              text: $t("Schedule"),
              value: "schedule",
              component: AppointmentAvailabilitySettings,
            },
          ]
        : []),
      ...(checkAuthorities(authorities.value, ["updateMyAppointmentType"])
        ? [
            {
              text: $t("Price"),
              value: "price",
              component: AppointmentTypesSettings,
            },
          ]
        : []),
    ];

    const activeTab = ref(itemsTabs[0].value);

    const appointmentTypes = computed<
      Record<
        AvailabilityIntervalType,
        {
          title: TranslateResult;
          text: TranslateResult;
        }
      >
    >(() => ({
      [AvailabilityIntervalType.ONLINE]: {
        title: activeTab.value === "schedule" ? $t("Online personal schedule") : $t("Online prices"),
        text:
          activeTab.value === "schedule"
            ? $t("Choose a time to schedule an online meeting with you.")
            : $t("Define an online meeting duration and pricing, offer various options for each type."),
      },
      [AvailabilityIntervalType.TOUR_GUIDE]: {
        title: activeTab.value === "schedule" ? $t("Offline personal schedule") : $t("Offline prices"),
        text:
          activeTab.value === "schedule"
            ? $t("Choose a time to schedule a tour.")
            : $t("Define the tour duration and pricing."),
      },
    }));

    return { itemsTabs, activeTab, appointmentTypes, AvailabilityIntervalType };
  },
});
